import { BuilderBranchConditionComponent } from './builder-branch-condition-component';

export class BuilderBranchCondition {
  questionGuid: string;
  branchQuestionGuid: string;
  conditionExpressionComponents: BuilderBranchConditionComponent[];

  constructor(
    questionGuid: string,
    branchQuestionGuid: string,
    conditionExpressionComponents: BuilderBranchConditionComponent[],
  ) {
    this.questionGuid = questionGuid;
    this.branchQuestionGuid = branchQuestionGuid;
    this.conditionExpressionComponents = conditionExpressionComponents;
  }
}
